var _circle, _circle2, _g, _g2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 175,
    r: 142,
    fill: "#F9E218"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5825_32521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 33,
    width: 284,
    height: 284
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 175,
    r: 142,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5825_32521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.203 163.209C316.962 172.91 296.586 174.145 270.046 153.998C268.181 157.558 261.925 157.248 255.915 152.161C248.386 145.788 249.913 136.34 257.731 135.993C255.374 121.711 269.961 124.944 266.719 117.13C263.478 109.315 264.288 105.273 273.202 105.004C282.116 104.735 296.433 118.208 283.685 126.022C296.91 136.056 322.954 128.868 323.715 143.807C334.52 148.927 336.141 164.556 320.203 163.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.046 153.998C296.586 174.145 316.962 172.91 320.203 163.209M320.203 163.209C336.141 164.556 334.52 148.927 323.715 143.807M320.203 163.209C322.905 149.196 309.669 154.047 293.732 147.58M323.715 143.807C313.991 139.199 304.266 141.112 294.812 134.645M323.715 143.807C322.954 128.868 296.91 136.056 283.685 126.022M281.306 123.867C282.039 124.663 282.836 125.378 283.685 126.022M288.599 137.879C278.019 131.942 272.591 129.495 268.34 134.645M269.15 146.232C274.283 156.742 264.829 159.706 255.915 152.161C248.386 145.788 249.913 136.34 257.731 135.993M262.668 136.801C260.82 136.173 259.169 135.929 257.731 135.993M257.731 135.993C255.374 121.711 269.961 124.944 266.719 117.13C263.478 109.315 264.288 105.273 273.202 105.004C282.116 104.735 296.433 118.208 283.685 126.022",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.825 145.444C252.5 135 228 168.5 231 171.5C234 174.5 271.149 155.888 261.825 145.444Z",
    fill: "#F9E218",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0248 162.286C71.3494 151.842 116 181.5 113 184.5C110 187.5 52.7001 172.73 62.0248 162.286Z",
    fill: "#F9E218",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 27L120.748 51C98.2484 80.5 110.248 121 120.748 176.5C131.248 232 89.2223 301.375 108.248 324.5L123.748 334C206.748 324.5 275.748 124 153.748 46L149.748 16.5L117.248 6L104.748 27Z",
    fill: "#F9C818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.236 331.5C207.236 322 275.748 124 153.748 46L142.736 45L137.236 48.5C183.5 173 147 278.5 124.236 331.5Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.736 18.5L118.236 9L137.236 48.5C142.736 45.5 151.736 47.5 151.736 47.5L147.736 18.5Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 27L120.748 51C98.2484 80.5 110.248 121 120.748 176.5C131.248 232 89.2223 301.375 108.248 324.5L123.748 334C206.748 324.5 275.748 124 153.748 46L149.748 16.5L117.248 6L104.748 27Z",
    stroke: "#6C4800",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.083 164.524C204.727 169.757 199.317 170.261 185.388 165.51C185.388 165.51 176.76 108.728 190.136 110.908C203.512 113.089 211.083 164.524 211.083 164.524Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12.7863,
    transform: "matrix(-1 0 0 1 188.014 142.786)",
    fill: "#35B6D2"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.83589,
    transform: "matrix(-1 0 0 1 196.111 136.393)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.74797,
    transform: "matrix(-1 0 0 1 190.097 144.226)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.227 142.786C175.227 149.848 180.952 155.573 188.014 155.573C175.227 149.179 176.293 135.86 188.014 130C180.952 130 175.227 135.725 175.227 142.786Z",
    fill: "#1F7FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 157.5L182 123H169L171 157.5H183Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.083 164.524C204.727 169.757 199.317 170.261 185.388 165.51C185.388 165.51 176.76 108.728 190.136 110.908C203.512 113.089 211.083 164.524 211.083 164.524Z",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3 101.875C176.85 114.253 170.85 164.898 170.85 164.898C154.31 164.046 150.297 164.093 133.85 154.899C133.85 154.899 129.75 89.4977 153.3 101.875Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.503 103.49C129.718 159.713 171.305 163.222 171.305 163.222C154.794 162.264 152.446 163.358 135.96 154.304C135.96 154.304 130.96 92.1491 153.503 103.49Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13.6095,
    transform: "matrix(-1 0 0 1 148.846 138.57)",
    fill: "#35B6D2"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.08286,
    transform: "matrix(-1 0 0 1 157.465 131.765)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.11805,
    transform: "matrix(-1 0 0 1 151.063 140.102)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.236 138.57C135.236 146.086 141.329 152.18 148.846 152.18C135.236 145.375 136.37 131.198 148.846 124.96C141.329 124.96 135.236 131.054 135.236 138.57Z",
    fill: "#1F7FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 106.962C150.404 78.9323 141.45 74.7838 132 104.462C143.35 86.1878 151.737 87.1008 170 106.962Z",
    fill: "#6C4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 114C189.108 85.9239 183.217 81.7686 177 111.496C184.467 93.1914 189.985 94.1059 202 114Z",
    fill: "#6C4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.871 183.782C200.69 243.818 135.514 245.701 139.15 171C161.64 186.958 185.112 187.947 208.871 183.782Z",
    fill: "#EB4D55",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15 171C153.095 182.039 185.631 187.268 198.994 185.525C195.223 195.846 195.221 201.738 183.888 201.212C172.555 200.686 144.905 193.078 140.312 190.173C139.731 182.962 138.876 178.747 139.15 171Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7195 209.262C22.9522 209.615 23.2296 209.971 23.555 210.329C28.9106 216.233 48.721 206.18 57.782 184.727C57.782 184.727 69.2776 186.06 72.2714 172.459C75.2651 158.858 68.1889 157.524 66.2838 156.724C64.3787 155.924 61.6571 156.991 58.6634 156.191C55.6696 155.391 53.4924 151.924 47.5051 151.124C41.5178 150.324 39.8843 154.591 34.4413 154.057C28.9983 153.524 28.4348 150.59 23.5552 150.057C18.6755 149.523 12.9408 152.724 11.0357 160.724C9.13057 168.725 15.7758 173.447 24.5956 173.526C13.4243 187.759 4.7644 192.775 9.17134 201.795C8.44646 203.815 8.42339 206.042 9.40273 208.729C10.4719 211.663 16.0591 214.074 22.7195 209.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9293 168.992C61.2432 174.754 59.7718 180.016 57.782 184.727M35.5299 187.127C30.0993 196.757 18.2799 202.533 22.7195 209.262M22.7195 209.262C22.9522 209.615 23.2296 209.971 23.555 210.329C28.9106 216.233 48.721 206.18 57.782 184.727M22.7195 209.262C16.0591 214.074 10.4719 211.663 9.40273 208.729C8.42339 206.042 8.44646 203.815 9.17135 201.795M27.6373 180.726C20.8107 191.065 11.4681 195.394 9.17135 201.795M9.17135 201.795C4.7644 192.775 13.4243 187.759 24.5956 173.526M30.9032 164.725C28.7598 168.02 26.6358 170.926 24.5956 173.526M24.5956 173.526C15.7758 173.447 9.13057 168.725 11.0357 160.724C12.9408 152.724 18.6755 149.523 23.5552 150.057C28.4348 150.59 28.9983 153.524 34.4413 154.057C39.8842 154.591 41.5178 150.324 47.5051 151.124C53.4924 151.924 55.6696 155.391 58.6634 156.191C61.6571 156.991 64.3787 155.924 66.2838 156.724C68.1889 157.524 75.2651 158.858 72.2714 172.459C69.2776 186.06 57.782 184.727 57.782 184.727M55.942 159.924C47.2329 156.457 44.7835 164.725 40.9733 175.659",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5825_32521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.203 163.209C316.962 172.91 296.586 174.145 270.046 153.998C268.181 157.558 261.925 157.248 255.915 152.161C248.386 145.788 249.913 136.34 257.731 135.993C255.374 121.711 269.961 124.944 266.719 117.13C263.478 109.315 264.288 105.273 273.202 105.004C282.116 104.735 296.433 118.208 283.685 126.022C296.91 136.056 322.954 128.868 323.715 143.807C334.52 148.927 336.141 164.556 320.203 163.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.046 153.998C296.586 174.145 316.962 172.91 320.203 163.209M320.203 163.209C336.141 164.556 334.52 148.927 323.715 143.807M320.203 163.209C322.905 149.196 309.669 154.047 293.732 147.58M323.715 143.807C313.991 139.199 304.266 141.112 294.812 134.645M323.715 143.807C322.954 128.868 296.91 136.056 283.685 126.022M281.306 123.867C282.039 124.663 282.836 125.378 283.685 126.022M288.599 137.879C278.019 131.942 272.591 129.495 268.34 134.645M269.15 146.232C274.283 156.742 264.829 159.706 255.915 152.161C248.386 145.788 249.913 136.34 257.731 135.993M262.668 136.801C260.82 136.173 259.169 135.929 257.731 135.993M257.731 135.993C255.374 121.711 269.961 124.944 266.719 117.13C263.478 109.315 264.288 105.273 273.202 105.004C282.116 104.735 296.433 118.208 283.685 126.022",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.825 145.444C252.5 135 228 168.5 231 171.5C234 174.5 271.149 155.888 261.825 145.444Z",
    fill: "#F9E218",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0248 162.286C71.3494 151.842 116 181.5 113 184.5C110 187.5 52.7001 172.73 62.0248 162.286Z",
    fill: "#F9E218",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 27L120.748 51C98.2484 80.5 110.248 121 120.748 176.5C131.248 232 89.2223 301.375 108.248 324.5L123.748 334C206.748 324.5 275.748 124 153.748 46L149.748 16.5L117.248 6L104.748 27Z",
    fill: "#F9C818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.236 331.5C207.236 322 275.748 124 153.748 46L142.736 45L137.236 48.5C183.5 173 147 278.5 124.236 331.5Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.736 18.5L118.236 9L137.236 48.5C142.736 45.5 151.736 47.5 151.736 47.5L147.736 18.5Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 27L120.748 51C98.2484 80.5 110.248 121 120.748 176.5C131.248 232 89.2223 301.375 108.248 324.5L123.748 334C206.748 324.5 275.748 124 153.748 46L149.748 16.5L117.248 6L104.748 27Z",
    stroke: "#6C4800",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.083 164.524C204.727 169.757 199.317 170.261 185.388 165.51C185.388 165.51 176.76 108.728 190.136 110.908C203.512 113.089 211.083 164.524 211.083 164.524Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12.7863,
    transform: "matrix(-1 0 0 1 188.014 142.786)",
    fill: "#35B6D2"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.83589,
    transform: "matrix(-1 0 0 1 196.111 136.393)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.74797,
    transform: "matrix(-1 0 0 1 190.097 144.226)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.227 142.786C175.227 149.848 180.952 155.573 188.014 155.573C175.227 149.179 176.293 135.86 188.014 130C180.952 130 175.227 135.725 175.227 142.786Z",
    fill: "#1F7FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 157.5L182 123H169L171 157.5H183Z",
    fill: "#F9E218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.083 164.524C204.727 169.757 199.317 170.261 185.388 165.51C185.388 165.51 176.76 108.728 190.136 110.908C203.512 113.089 211.083 164.524 211.083 164.524Z",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3 101.875C176.85 114.253 170.85 164.898 170.85 164.898C154.31 164.046 150.297 164.093 133.85 154.899C133.85 154.899 129.75 89.4977 153.3 101.875Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.503 103.49C129.718 159.713 171.305 163.222 171.305 163.222C154.794 162.264 152.446 163.358 135.96 154.304C135.96 154.304 130.96 92.1491 153.503 103.49Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13.6095,
    transform: "matrix(-1 0 0 1 148.846 138.57)",
    fill: "#35B6D2"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.08286,
    transform: "matrix(-1 0 0 1 157.465 131.765)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.11805,
    transform: "matrix(-1 0 0 1 151.063 140.102)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.236 138.57C135.236 146.086 141.329 152.18 148.846 152.18C135.236 145.375 136.37 131.198 148.846 124.96C141.329 124.96 135.236 131.054 135.236 138.57Z",
    fill: "#1F7FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 106.962C150.404 78.9323 141.45 74.7838 132 104.462C143.35 86.1878 151.737 87.1008 170 106.962Z",
    fill: "#6C4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 114C189.108 85.9239 183.217 81.7686 177 111.496C184.467 93.1914 189.985 94.1059 202 114Z",
    fill: "#6C4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.871 183.782C200.69 243.818 135.514 245.701 139.15 171C161.64 186.958 185.112 187.947 208.871 183.782Z",
    fill: "#EB4D55",
    stroke: "#6C4800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15 171C153.095 182.039 185.631 187.268 198.994 185.525C195.223 195.846 195.221 201.738 183.888 201.212C172.555 200.686 144.905 193.078 140.312 190.173C139.731 182.962 138.876 178.747 139.15 171Z",
    fill: "white",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7195 209.262C22.9522 209.615 23.2296 209.971 23.555 210.329C28.9106 216.233 48.721 206.18 57.782 184.727C57.782 184.727 69.2776 186.06 72.2714 172.459C75.2651 158.858 68.1889 157.524 66.2838 156.724C64.3787 155.924 61.6571 156.991 58.6634 156.191C55.6696 155.391 53.4924 151.924 47.5051 151.124C41.5178 150.324 39.8843 154.591 34.4413 154.057C28.9983 153.524 28.4348 150.59 23.5552 150.057C18.6755 149.523 12.9408 152.724 11.0357 160.724C9.13057 168.725 15.7758 173.447 24.5956 173.526C13.4243 187.759 4.7644 192.775 9.17134 201.795C8.44646 203.815 8.42339 206.042 9.40273 208.729C10.4719 211.663 16.0591 214.074 22.7195 209.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9293 168.992C61.2432 174.754 59.7718 180.016 57.782 184.727M35.5299 187.127C30.0993 196.757 18.2799 202.533 22.7195 209.262M22.7195 209.262C22.9522 209.615 23.2296 209.971 23.555 210.329C28.9106 216.233 48.721 206.18 57.782 184.727M22.7195 209.262C16.0591 214.074 10.4719 211.663 9.40273 208.729C8.42339 206.042 8.44646 203.815 9.17135 201.795M27.6373 180.726C20.8107 191.065 11.4681 195.394 9.17135 201.795M9.17135 201.795C4.7644 192.775 13.4243 187.759 24.5956 173.526M30.9032 164.725C28.7598 168.02 26.6358 170.926 24.5956 173.526M24.5956 173.526C15.7758 173.447 9.13057 168.725 11.0357 160.724C12.9408 152.724 18.6755 149.523 23.5552 150.057C28.4348 150.59 28.9983 153.524 34.4413 154.057C39.8842 154.591 41.5178 150.324 47.5051 151.124C53.4924 151.924 55.6696 155.391 58.6634 156.191C61.6571 156.991 64.3787 155.924 66.2838 156.724C68.1889 157.524 75.2651 158.858 72.2714 172.459C69.2776 186.06 57.782 184.727 57.782 184.727M55.942 159.924C47.2329 156.457 44.7835 164.725 40.9733 175.659",
    stroke: "#6C4800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5825_32521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 254,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6ce118c5ec88c1cd28e916e459236982.svg";
export { ForwardRef as ReactComponent };